import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganization } from '../useOrganization';
import { setNotificationsQueryData } from './useReadNotifications.utils';
import { UserNotificationDTO } from './userNotifications.models';

function useReadSystemNotification() {
  const queryClient = useQueryClient();
  const { organization } = useOrganization();

  return useMutation({
    mutationKey: ['read-system-notification'],
    mutationFn: async (notificationIds: string[]) => {
      notificationIds.forEach((id) => {
        localStorage.setItem(`${id}-${organization?.workspace_id}`, 'read');
      });

      queryClient.setQueryData<{ [key: string]: UserNotificationDTO }>(
        ['system-notifications', { workspace_id: organization?.workspace_id }],
        (oldData) => {
          return setNotificationsQueryData({
            oldData,
            notificationIds,
            status: 'READ',
          });
        }
      );
    },
  });
}

export { useReadSystemNotification };
